import angular from 'angular'
import { management } from 'redevConfig'

const list = (management && management.list) || ''

const managementListPage = list
  ? require(`redevelopment/input/management/${list.templateName}`)
  : require('./view/managementList.html')
const managementListCtrl = list
  ? require(`redevelopment/input/management/${list.controllerName}`)
  : require('./managementListCtrl')
import exportModalCtrl from './exportModalCtrl'
export default angular
  .module('input.inputInvoice.management', [])
  .config([
    '$stateProvider',
    function config($stateProvider) {
      $stateProvider
        .state('input.inputInvoice.management', {
          url: '/management',
          abstract: true,
          template: '<div ui-view></div>',
          title: '发票管理',
          default: 'input.inputInvoice.management.list',
        })
        .state('input.inputInvoice.management.list', {
          url: '/list',
          template: managementListPage,
          controller: 'managementListCtrl',
        })
    },
  ])
  .controller('exportModalCtrl', exportModalCtrl)
  .controller('managementListCtrl', managementListCtrl.default).name



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/management/index.js